import { useProductsContext } from '@/creditflowresearch/application/Deal/contexts/ProductsContext';
import { ICorporatePayload } from '@/creditflowresearch/application/Deal/types';
import { ICorporateDeal } from '@/creditflowresearch/domain/vo/Deals/CorporateDeal';
import { CorporateProduct } from '@/creditflowresearch/domain/Product';
import useDeals, { IDealsCollection } from './useDeals';

interface IUseCorporateDealsProps {
  deals: IDealsCollection<ICorporateDeal, ICorporatePayload>,
  fetch?: (payload: ICorporatePayload) => Promise<IDealsCollection<ICorporateDeal, ICorporatePayload>>,
  additionalFilters?: ICorporatePayload,
}

const useCorporateDeals = ({ deals, fetch, additionalFilters }: IUseCorporateDealsProps) => {
  const { selectedTab } = useProductsContext();
  const isActive = selectedTab?.productIds?.some((id) => CorporateProduct.CORPORATE_PRODUCT_IDS.includes(id)) ?? true;

  return useDeals({
    deals,
    fetch,
    additionalFilters,
    isActive,
  });
};

export default useCorporateDeals;
